import React from 'react'
import styled from 'styled-components'
import { LIGHTGRAY } from '../../styles/colors.style'
import PaginatorComponent from './paginator.component'

const StyledEmptyDataset = styled.div`
	align-items: center;
	border-bottom: 1px solid ${LIGHTGRAY};
	display: flex;
	font-size: 2rem;
	height: 10rem;
	justify-content: center;
`

const StyledPaginator = styled.div`
	margin-top: 2rem;
`

const StyledSpan = styled.span`
	text-align: center;
`

function sortData() {
	const { rows, sidx, sord, sortable } = this.state
	const col = sortable && sortable.cols.find(({ key }) => key === sidx)

	if (col.sortFn) {
		rows.sort(col.sortFn.bind(null, sord, sidx))
	} else {
		const sortFn =
			sord === 'asc'
				? (a, b) => {
						if (a[sidx] == null || a[sidx] == '') return 1
						if (b[sidx] == null || b[sidx] == '') return -1
						if (a[sidx] === b[sidx]) return 0

						if (!isNaN(+a[sidx])) return +a[sidx] - +b[sidx]

						const formattedDate = new Date(
							a[sidx]
								.split('/')
								.slice(0, 3)
								.reverse()
								.join('-')
						)
						if (formattedDate != 'Invalid Date') {
							const dateToCompare = new Date(
								b[sidx]
									.split('/')
									.slice(0, 3)
									.reverse()
									.join('-')
							)
							if (dateToCompare == 'Invalid Date') return -1
							return +formattedDate - +dateToCompare
						}

						return a[sidx].localeCompare(b[sidx])
				  }
				: (a, b) => {
						if (a[sidx] == null || a[sidx] == '') return 1
						if (b[sidx] == null || b[sidx] == '') return -1
						if (a[sidx] === b[sidx]) return 0

						if (!isNaN(+b[sidx])) return +b[sidx] - +a[sidx]

						const formattedDate = new Date(
							b[sidx]
								.split('/')
								.slice(0, 3)
								.reverse()
								.join('-')
						)
						if (formattedDate != 'Invalid Date') {
							const dateToCompare = new Date(
								a[sidx]
									.split('/')
									.slice(0, 3)
									.reverse()
									.join('-')
							)
							if (dateToCompare == 'Invalid Date') return -1
							return +formattedDate - +dateToCompare
						}

						return b[sidx].localeCompare(a[sidx])
				  }
		rows.sort(sortFn)
	}
}

function renderDefaultPaginator({
	page,
	goToPage,
	goToNext,
	goToPrevious,
	rowsPerPage,
	totalRows,
	loading
}) {
	return totalRows > 0 ? (
		<StyledPaginator>
			<PaginatorComponent
				goToPage={goToPage}
				goToNext={goToNext}
				goToPrevious={goToPrevious}
				loading={loading}
				page={page}
				rowsPerPage={rowsPerPage}
				totalRows={totalRows}
			/>
		</StyledPaginator>
	) : (
		<div style={{ height: '34px' }} />
	)
}

function goToNext() {
	if (this.state.loading) return
	let { page } = this.state
	goToPage.call(this, ++page)
}

function goToPrevious() {
	if (this.state.loading) return
	let { page } = this.state
	goToPage.call(this, --page)
}

function updatePage(pageNumber) {
	this.setState({ page: pageNumber }, setDisplayData)
}

function goToPage(pageNumber) {
	const { loading, page } = this.state
	const { loadonce } = this.props
	if (loading) return
	if (pageNumber == page) return

	if (loadonce) {
		updatePage.call(this, pageNumber)
	} else {
		this.setState({ page: pageNumber }, PaginationFunctions.getData)
	}
}

function setDisplayData() {
	const { page, rows, rowsPerPage } = this.state
	const { loadonce } = this.props
	const startIndex = (page - 1) * rowsPerPage
	this.setState({
		displayData: loadonce
			? rows.slice(startIndex, startIndex + rowsPerPage)
			: rows
	})
}

export default class PaginationFunctions {
	/**
	 * Sorts the rows based on the sorting function passed as prop, otherwise, sorts using string localeCompare
	 */
	static getData() {
		const { page, rowsPerPage, loading, sidx, sord } = this.state

		if (loading) return

		const { getData, loadonce, params } = this.props

		this.setState({ loading: true }, () =>
			getData(
				Object.assign(
					{},
					loadonce ? {} : { page, rowsPerPage, sidx, sord },
					params
				)
			).then(({ rows, totalRows }) => {
				this.setState({ rows, totalRows, loading: false }, setDisplayData)
			})
		)
	}

	/**
	 * Gets the sorting order -> asc or desc
	 * @param {string} nextSidx sort index
	 * @returns {string} Sorting order
	 */
	static getSord(nextSidx) {
		const { sord, sidx, sortable } = this.state
		if (sidx === nextSidx) {
			return sord === 'asc' ? 'desc' : 'asc'
		} else {
			return (sortable && sortable.defaultOrder) || 'asc'
		}
	}

	/**
	 * Renders the paginator if it was passed in the props,
	 * othervwise, renders the default paginator.
	 *
	 * @returns {JSX.Element} Paginator
	 */
	static renderPaginator() {
		const { loading, page, rowsPerPage, totalRows } = this.state
		const props = {
			goToPage: goToPage.bind(this),
			goToNext: goToNext.bind(this),
			goToPrevious: goToPrevious.bind(this),
			loading,
			page,
			rowsPerPage,
			totalRows
		}
		return (this.props.renderPaginator || renderDefaultPaginator)(props)
	}

	static renderEmptyDataset() {
		const { emptyDatasetText } = this.props
		if (this.state.totalRows <= 0 && !this.state.loading) {
			return (
				<StyledEmptyDataset>
					<StyledSpan>
						{emptyDatasetText
							? emptyDatasetText
							: 'Não existem resultados para serem exibidos. Altere os filtros e refaça a pesquisa.'}
					</StyledSpan>
				</StyledEmptyDataset>
			)
		}
	}

	static sortRows() {
		const { loadonce } = this.props
		if (loadonce) {
			sortData.call(this)
			setDisplayData.call(this)
		} else {
			PaginationFunctions.getData.call(this)
		}
	}
}
